<svelte:options tag="fds-local-files"></svelte:options>
<script>
    import { onMount } from 'svelte'
    import {get_current_component} from "svelte/internal"
    let host = get_current_component()
    import fdsHelper from "@fds-components/fds-helper"
//    let path = fdsHelper.get_href()

    import { version as componentversion,name } from '../package.json';

    /**
     * Get information about component
     * @param  {("api" | "examples" | "css")} type the info type
     */
    export async function getInfo(type) {
        if (type==="version"){
            return new Promise(resolve => {
                resolve(componentversion)
            });
        }
        let res = await fdsHelper.getInfo(type,name)
        return res;    
    }

    /**
     * version of component
     * @type {string}
     */
    export const version = componentversion
    /**
     * Description 
     * @type {string}
     */
    export let description=""

    /**
     * change mode to load_save_as only
     * @type {"default"|"load_save_as"}
     */
     export let mode="default"
    /**
     * the contents to store or loaded in text format (not binary)
     * @type {string}
     */
    export let contents=""

    /**
     * the contents to store or loaded in array_buffer format (binary)
     * @type {string}
     */
     export let array_buffer=""

    /**
     * design mode
     * @type {"buttons"|"headless"}
     */
     export let design="buttons"
    /**
     * the accepted file types (mime plus extension)
     *  @type {{}}
     */
    export let accept={}

    /**
     * do not set document title automatically
     * @type {boolean}
     */
    export let ignore_document_title=false

    /**
     * the name of the file after loading, read-only
     * @type {string}
     */
    export let file_name=""
    let langid
    let _lang={
        save: {de: "Speichern",en:"save"},
        load: {de: "Laden...",en:"Load..."},
        save_as: {de: "Speichern als...",en:"Save as..."},
        sure: {de: "Sind Sie sicher?",en:"Are you sure?"},

    }

    onMount(()=> {
        let userLang = navigator.language || navigator.userLanguage; 
        langid=userLang.substring(0,2)
        if (langid!=="de") langid="en"
        host.addEventListener("change", () => {
            somethingChanged = true
        })
    })
    let fileHandle
    let somethingChanged = false      // has to be set to true in fds-form-editor

    /**
     * Will be fired if  file is loaded
     * @event load
     */
    export async function load() {
        if (somethingChanged) {
                let yes = confirm(_lang.sure[langid])
                if (!yes) return
         }
            [fileHandle] = await window.showOpenFilePicker({
                types: [{
                    description: description,
                    accept:accept,
                }]
            })
            const file = await fileHandle.getFile()
            contents = await file.text()
            array_buffer= await file.arrayBuffer()
            file_name=file.name
            if (!ignore_document_title) document.title=file.name
            host.dispatchEvent(new CustomEvent('load', { detail: file.name }))
            somethingChanged = false
    }

    $: if (contents) {
         if (saveType==="as") {
             saveAsNow()
            saveType=""
         }
         if (saveType==="overwrite") {
            saveOverwrite()
            saveType=""
         }         
     }    
    let saveType=""
    /**
     * Will be fired if  file is saved
     * @event save
     */
    export function save() {
        saveType="overwrite"           
        host.dispatchEvent(new CustomEvent('save',  { }))
    }
    async function saveOverwrite() {
        somethingChanged = false
         if (!fileHandle) {
            fileHandle = await window.showSaveFilePicker()
        }
        const writable = await fileHandle.createWritable();
        await writable.write(contents)
        await writable.close()
    }

     async function saveAsNow() {
        fileHandle = await window.showSaveFilePicker({
                types: [{
                    description: description,
                    accept:accept,
                }]
            })
        const writable = await fileHandle.createWritable()
        await writable.write(contents)
        somethingChanged = false
        const file = await fileHandle.getFile()
        file_name=file.name
        document.title=file.name
        await writable.close()
    }    
          
    export function saveAs() { 
        saveType="as"           
        host.dispatchEvent(new CustomEvent('save',  { }))
    }
</script>
{#if design==="buttons"}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <fds-button on:click={() => { load()}}>
        <fds-icon name="far folder-open" height="14" style="margin-right:5px"></fds-icon>
        {_lang.load[langid]}
    </fds-button>
    {#if mode!=="load_save_as"}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <fds-button type="primary"  disabled={!somethingChanged} on:click={() => { save()}}>
        <fds-icon name="far fa-save" height="14" style="margin-right:5px"></fds-icon>
        {_lang.save[langid]}
    </fds-button>
    {/if}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <fds-button on:click={() => { saveAs()}}>
        <fds-icon name="far fa-save" height="14" style="margin-right:5px"></fds-icon>
        {_lang.save_as[langid]}
    </fds-button> {file_name}
{/if}   
<style>
* { box-sizing: border-box; }
 
</style>
